import React, { useMemo } from 'react';
import { Table } from 'reactstrap';
import { reduxForm } from 'redux-form';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import { partial } from '../../../util/translation/translation';
import { formatDate } from '../../../util/date-and-time';
import { formatMoney } from '../payments';

const InvitesCard = ({ invites, participantSearch, currency }) => {
  const s = partial('shared');
  const p = partial('EventParticipantsPage');
  const ep = partial('EventPayments');
  // Invites made with a price (paid events) say what they cost
  const showPrice = invites.some(
    (invite) => invite.price !== undefined && invite.price !== null
  );
  const priceText = (invite) => {
    if (invite.price === undefined || invite.price === null) return '-';
    if (!Number(invite.price)) return ep('statusFree');
    return Number(invite.bookingFee) > 0
      ? ep('priceWithFee', {
          price: formatMoney(invite.price, invite.currency || currency),
          fee: formatMoney(invite.bookingFee, invite.currency || currency),
        })
      : formatMoney(invite.price, invite.currency || currency);
  };
  const search = participantSearch.trim().toLowerCase();
  const filteredInvites = useMemo(
    () =>
      invites.filter((invite) => invite.email?.toLowerCase().includes(search)),
    [invites, search]
  );

  const renderInvites = () => {
    if (!filteredInvites.length) {
      return (
        <tr>
          <td colSpan={showPrice ? 4 : 3} className="text-muted text-center">
            {search
              ? p('noSearchResults', { query: participantSearch })
              : p('noInvites')}
          </td>
        </tr>
      );
    }
    return filteredInvites.map((invite) => {
      const registered = !!invite.registeredAt;
      return (
        <tr key={`renderInvites-${invite.id}`}>
          <td className="table-stack__primary">{invite.email}</td>
          <td data-label={p('hasRegistered')}>
            <div className="status-dot-group">
              <span
                className={`status-dot ${
                  registered ? 'status-dot--on' : 'status-dot--off'
                }`}
              >
                {registered ? <CheckIcon /> : <CloseIcon />}
              </span>
              {registered && formatDate(invite.registeredAt)}
            </div>
          </td>
          <td data-label={p('sentAt')}>{formatDate(invite?.createdAt)}</td>
          {showPrice && <td data-label={ep('price')}>{priceText(invite)}</td>}
        </tr>
      );
    });
  };

  return (
    <Table responsive striped className="table--roomy table--stack">
      <thead>
        <tr>
          <th>{s('email')}</th>
          <th>{p('hasRegistered')}</th>
          <th>{p('sentAt')}</th>
          {showPrice && <th>{ep('price')}</th>}
        </tr>
      </thead>
      <tbody>{renderInvites()}</tbody>
    </Table>
  );
};

const reduxF = reduxForm({
  form: 'EventsPariticipantForm',
  enableReinitialize: true,
});

export default reduxF(InvitesCard);
